module.exports = __webpack_public_path__ + "img/api_settings_active.0eae1061.svg";